module.exports = __webpack_public_path__ + "img/packet.5fce6e98.svg";